import React from "react"
import ScenarioEquilibrage from './scenario_equilibrage'
import ScenarioEquilibrageGestionnaire from './scenario_equilibrage_gestionnaire'
import { connect } from "react-redux"
import * as actions from '../../../actions'
import ScenarioService from '../../../service/sfp/scenario-service'
import AdminComponent from "./admin-component"
import TableDefinition from "./scenario-table-defination"
import Operations from "../common/operations"
import { sortServices } from "../../../domain/sfp/service-domain"
import { getTotalInterestByYear } from "../../../domain/sfp/loan-domain"
import { getProfile, Profile } from "../../../domain/sfp/user-domain";


class ScenarioIndex extends React.Component {
    state = {
		currentTab: "revenues",
		shownChapters: [],
		is_gest: false,
		adminId: null,
		shownChaptersDetail:[],
	}

	componentWillMount() {
		if (!this.props.me.consultedLocalAuthority && !this.props.me.managedLocalAuthority && this.props.me.roles.indexOf("ROLE_ADMIN") == -1 && this.props.me.roles.indexOf("ROLE_SUPER_ADMIN") == -1) {
			if(this.props.me.roles.length > 0){
				this.setState({is_gest: true, adminId: this.props.me.id})
			}			
		}
    }
          

     
    render() {
        if (this.props.scenario) {
        return(
			<ScenarioEquilibrage	scenario={this.props.scenario}
			shownChapters = {this.state.shownChaptersDetail}
            tableDefinition={this._getTableDefinition()}
            headers={this._getHeaders()}
            data={this._getData()}
            isSuperAdmin={!this.state.is_gest/*(this.props.me.managedLocalAuthority && !this.props.me.consultedLocalAuthority) || (this.props.me.roles.indexOf("ROLE_ADMIN") !== -1 && this.props.me.roles.indexOf("ROLE_SUPER_ADMIN") !== -1)*/}
            isGest={this.state.is_gest}
            isAdmin={this.state.adminId !== null}
            currentTab={this.state.currentTab}
            themes={this._getThemes()}
            onTabChange={this._handleTabChange.bind(this)}
            onChange={(data)=>this._handleChange(data)}
            onMouseDown={(theme)=>this._handleMouseDown(theme)}
            onBack={this.props.onBack}
			onToggleChapter={(chapter)=>this._handleToggleChapter(chapter)}
			onToggleChapterRemove={(chapter)=>this._handleToggleChapterRemove(chapter)}
			CopyAllData={(s)=>this._handleCopyAllData(s)}
            onToggleAdmin={this._handleToggleAdmin.bind(this)}/>
            // <ScenarioEquilibrageGestionnaire/>
        )
    } else return null
    }
    _getTableDefinition() {
		const consulted = getProfile(this.props.me) === Profile.LocalAuthorityConsultant
		return TableDefinition(
			this.props.scenarii,
			this.props.scenario,
			this.props.ppi,
			this.props.localAuthority,
			this.state.currentTab,
			this.state.shownChapters,
			this.state.adminId,
			this._getThemes(),
			consulted
		)
	}

	_handleCopyAllData(s){
		ScenarioService.updateArbitrageThemeValueCopy(s)
		.then(null, this._dispatchReceiveError.bind(this))
	}

	_getOperations() {
		return new Operations(this.props.scenario, this.props.ppi, this.props.localAuthority)
	}

	_getHeaders() {
		let headers = []

		//if (!this.state.adminId) {
			headers.push("<div class='global-header'><div><i class='fa fa-building'></i></div><div><span class='global-year'>" + this.props.scenario.year + "</span></div></div>")
			headers.push("<div class='global-header'><div><i class='fa fa-user'></i></div><div><span class='global-year'>" + this.props.scenario.year + "</span></div></div>")
			//headers.push(this.props.scenario.year + " (Scénario)")
			//headers.push(this.props.scenario.year + " (Gestionnaires)")
		//}

		let validator
		this._getThemes().map(theme => {
			validator = this.props.scenario.validated_themes.find(vt => vt.theme_id == theme.id)
			headers.push("<div class='theme-header" + (validator && validator.validated ? " theme-validated" : "") + "'><div><i class='fa fa-check'></i></div><div class='theme-name'><span title='" + (theme.description || theme.label) + "'>" + theme.label + "</span><div><i class='fa fa-chevron-down' style='margin-left: 5px'></i></div> </div></div>")
		})

		return headers
	}

	_getData() {
		let data = []

		let previous_scenario = null
		const totalInterestByYear = Math.round(getTotalInterestByYear(this.props.loans, this.props.scenario.year))
		if (this.props.scenario.year == (new Date()).getFullYear() + 1) {
			let previous_scenarii = this.props.scenarii.find(s => s.year == this.props.scenario.year - 1)
			if (previous_scenarii) {
				previous_scenario = previous_scenarii.scenarii.find(s => s.validated)
			}
		}

		let row, value, totalRow = ["Total"]
		let validator, theme_values
		this._getTableDefinition().rows.map(r => {
			row = []
			row.push(r.title)

			//if (!this.state.adminId) {
				let scenarioSum = 0, adminSum = 0
				if (r.account) {
					// this.props.scenario.themes.filter(t => t.account_id == r.account.id && t.receipts == (this.state.currentTab == "revenues")).map(t => {
					// 	adminSum += t.amount
					// })
					scenarioSum = this._getOperations().findValue(this.props.scenario.year, r.account.id, r.chapter.id, r.chapter.receipts, previous_scenario)
					if (r.account.number === "66111") scenarioSum = totalInterestByYear
				} else if (r.chapter) {
					// this.props.localAuthority.accounts.filter(a => r.chapter.id == (a.chapter ? a.chapter.id : -1)).map(a => {
					// 	this.props.scenario.themes.filter(t => t.account_id == a.account.id && t.receipts == (this.state.currentTab == "revenues")).map(t => {
					// 		adminSum += t.amount
					// 	})
					// })
					r.chapter.accounts.map(account => {
						scenarioSum += this._getOperations().findValue(this.props.scenario.year, account.id, r.chapter.id, r.chapter.receipts, previous_scenario)
						if (account.number === "66111") scenarioSum = totalInterestByYear
					})
				}

				row.push(scenarioSum)
				row.push(adminSum)
				if (!this.state.adminId && r.chapter && !r.account) {
					if (totalRow.length == 1) {
						totalRow.push(scenarioSum)
					} else {
						totalRow[1] += scenarioSum
					}
					if (totalRow.length == 2) {
						totalRow.push(adminSum)
					} else {
						totalRow[2] += adminSum
					}
				}

			this._getThemes().map((theme, themeIndex) => {
				if (r.chapter || r.account) {
					theme_values = this.props.scenario.arbitrageScenarioAccountThemes.filter(t => t.theme_id == theme.id && t.amount !== null && t.amount !== undefined && t.receipts == (this.state.currentTab == "revenues"))
					validator = this.props.scenario.validated_themes.find(vt => vt.theme_id == theme.id)
					if (r.account) {
						value = this.props.scenario.arbitrageScenarioAccountThemes.find(t => (t.account_id == r.account.id && t.theme_id == theme.id && t.receipts == (this.state.currentTab == "revenues")))
						value = {
							amount: value ? Math.round(value.amount) : null,
							checked: value ? "checked" : "not-checked",
							theme,
							theme_validated: validator && validator.validated,
							// receipts:value ?value.receipts,
							account_id:r.account.id

						}
					} else if (r.chapter) {
						let accounts = this.props.scenario.arbitrageScenarioAccountThemes.filter(t => (t.theme_id == theme.id && (r.accountIds.indexOf(t.account_id) !== -1) && t.receipts == (this.state.currentTab == "revenues")))
						value = 0
						accounts.map(a => {
							value += a.amount
						})
						value = {
							amount: Math.round(value),
							checked: r.accountsLength == accounts.length ? "checked" : (accounts.length > 0 ? "partial" : "not-checked"),
							theme_validated: validator && validator.validated,
							theme_has_values: theme_values.filter(tv => (tv.chapter && tv.chapter.id == r.chapter.id) || (!tv.chapter && ((this.state.currentTab == "revenues" && r.chapter.id == -1) || (this.state.currentTab == "spending" && r.chapter.id == -2)))).length > 0,
							theme_values,

						}
					}
					value.theme = theme
					if (this.state.adminId) value = value.amount
					row.push(value)
				}

				if (!this.state.adminId && r.chapter && !r.account) {
					if (totalRow.length <= themeIndex+3) {
						totalRow.push(value.amount)
					} else {
						totalRow[themeIndex + 3] += value.amount
					}
				}

			})

			if (r.account || r.chapter) {
				data.push(row)
			}
		})

		if (!this.state.adminId) {
			data.push(totalRow)
		}

		return data
	}

	_getThemes() {
		let themes = []
		this.props.scenario.arbitrage.arbitragePoliticalApproaches.map(res=>{
				res.servicePoliticalApproaches.map(r=>{
					themes.push(r.service) 
			})
		})
		sortServices(themes)

		if (this.state.adminId && this.state.is_gest) {
			let scenarioThemeIds = this.props.scenario.arbitrageScenarioAccountThemes.map(t => t.theme_id)
			themes = themes.filter(t => (t.responsible.id == this.state.adminId && scenarioThemeIds.indexOf(t.id) !== -1))
			themes = themes.filter(t =>(_.get(this.props, "me.services", []).map(s => s.id).indexOf(t.id) !== -1)) //t.referents.map(a => a.id).indexOf(this.state.adminId) !== -1))
		}
		return themes
	}

	_updateScenario(scenario) {
		this.props.onScenarioUpdated(scenario)
	}

	_handleTabChange(type) {
		this.setState({currentTab: type})
	}

	tab(res){
		if(this.state.currentTab == "revenues" && res.receipts == true){
			return true
		}
		if(this.state.currentTab == "spending" && res.receipts == false){
			return true
		}
	}

	_handleChange = async(data) => {
		let scenario = this.props.scenario
		let match = false
				if (data.account) {
					if (data) {
					await scenario.arbitrageScenarioAccountThemes.forEach((res,i)=>{
							if(res.account_id == data.account.id && res.theme_slug == data.slug && this.tab(res) ){
							   match = true
							   scenario.arbitrageScenarioAccountThemes.splice(i, 1)
							   scenario.arbitrageScenarioAccountThemes.push({
								theme_id: data.theme.id,
								account_id: data.account.id,
								receipts: this.state.currentTab == "revenues",
								amount: data.amount ? data.amount:0,
								account_name:data.title,
								theme_slug:data.slug,
							})
							}
						})
						if(!match){
							scenario.arbitrageScenarioAccountThemes.push({
								theme_id: data.theme.id,
								account_id: data.account.id,
								receipts: this.state.currentTab == "revenues",
								amount: data.amount ? data.amount:0,
								account_name:data.title,
								theme_slug:data.slug,
							})
						}	
						ScenarioService.updateArbitrageThemeValue(this.props.scenario, data.account, data.theme, data.amount ? data.amount:0, this.state.currentTab == "revenues")
							.then(null, this._dispatchReceiveError.bind(this))
					} 
					// else {
					// 	let index = scenario.arbitrageScenarioAccountThemes.map(t => (t.theme_id + "-" + t.account_id)).indexOf(data.theme.id + "-" + data.account.id)
					// 	scenario.arbitrageScenarioAccountThemes.splice(index, 1)
					// 	ScenarioService.deleteAccountTheme(this.props.scenario, data.account, data.theme)
					// 		.then(null, this._dispatchReceiveError.bind(this))
					// }
				} 	
				this._updateScenario(scenario)
	}

	_handleMouseDown(theme) {
		if (!this.state.adminId ) {
				this.props.onCustomAction({action:"toggle_valid", actionData: { theme } })
		}
	}

	_handleToggleChapterRemove(chapter){
		let shownChapters = this.state.shownChapters
		let shownChaptersDetail = this.state.shownChaptersDetail
		let index
		if ((index = shownChapters.indexOf(chapter.id)) !== -1) {
			shownChapters.splice(index, 1)
			shownChaptersDetail.splice(index, 1)
			this.setState({shownChapters,shownChaptersDetail})
		}
	}

	_handleToggleChapter(chapter) {
		let shownChapters = this.state.shownChapters
		let shownChaptersDetail = this.state.shownChaptersDetail
		let index
		if ((index = shownChapters.indexOf(chapter.id)) == -1) {
			shownChapters.push(chapter.id,)
			shownChaptersDetail.push({label:chapter.label,tab:this.state.currentTab})
		}
		this.setState({shownChapters,shownChaptersDetail})
	}

	_handleToggleAdmin() {
		this.setState({adminId: this.state.adminId ? null : 4})
	}

	_dispatchReceiveError(error) {
		this.props.actions.throwError(error);
		this.setState({loading: false});
	}

}

const mapStateToProps = (state) => ({
	me: state.currentUser,
	currentServices: state.currentLocalAuthorityServices
})

export default connect(mapStateToProps)(ScenarioIndex)


// WEBPACK FOOTER //
// ./src/component/scenarii/admin/scenario_index.js